import React from 'react';
import {injectIntl} from "react-intl";
import moment from "moment";
import Constants from "../../../services/Constants";
import SATimePicker from "../../common/input/SATimePicker";
import SAInputNumber from "../../common/input/SAInputNumber";
import {Dropdown} from "antd";
import SAInputComponent from "../../common/input/SAInputComponent";
import Time from "../../../services/Time";

class AddDayConfigurationMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState = () => {
    const {data = {}} = this.props;
    return {
      slot: {
        startTime: data.startTime,
        endTime: data.endTime,
        slotDuration: data.slotDuration,
        numberOfTeams: data.numberOfTeams
      },
      visible: false,
    };
  };

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.data) {
      this.setState({slot: nextProps.data})
    }
  }

  resetState = () => {
    this.setState(this.getInitialState());
  };

  onTimePickerChange = (time, name) => {
    const {slot} = this.state;
    slot[name] = time ? moment(time).format(Constants.TIME_FORMAT_API) : undefined;
    this.setState({slot});
  };

  onDurationChange = (time, name) => {
    const {slot} = this.state;
    slot[name] = time ? `PT${time.hour()}H${time.minute()}M` : undefined;
    this.setState({slot});
  };

  onInputNumberChange = (number, name) => {
    const {slot} = this.state;
    slot[name] = number;
    this.setState({slot});
  };

  handleVisibleChange = () => {
    this.setState({visible: true});
  };

  verifyInput = (input) => {
    const errors = [];

    Object.keys(input).forEach(key => {
      if (!input[key]) {
        errors[key] = {message: 'error.not.null'};
      }
    });
    if (errors.length) {
      return errors;
    }

    const startTime = moment(input.startTime, "HH:mm");
    const endTime = moment(input.endTime, "HH:mm");
    const duration = moment.duration(input.slotDuration);
    const betweenStartEnd = moment.duration(endTime.diff(startTime));

    if (startTime.isSameOrAfter(endTime)) {
      errors['endTime'] = {message: 'error.greater.or.equal', args: input.startTime};
    }

    if (betweenStartEnd.asMinutes() < duration.asMinutes()) {
      errors['slotDuration'] = {
        message: 'error.less.or.equal',
        args: Time.durationToMoment(moment.duration(startTime.diff(endTime)), Constants.TIME_FORMAT_DISPLAY).format(Constants.TIME_FORMAT_DISPLAY)
      };
    }
    return errors;
  };

  onSave = () => {
    const errors = this.verifyInput(this.state.slot);
    this.setState({errors});

    if (Object.keys(errors).length === 0) {
      this.setState({visible:false});
      this.props.onValidate(this.state.slot);
      this.resetState();
    }
  };

  render() {
    const {intl:{formatMessage}} = this.props;
    const {errors = {}, slot: {startTime, endTime, slotDuration, numberOfTeams}} = this.state;
    const dropdownPositionClassName = "dropdown--bottom-" + (this.props.dropdownPosition || "left");

    const overlay = (
      <div className={"dropdown dropdown--md slot-menu--overlay " + dropdownPositionClassName}>
        <ul className="list">
          <li>
            <SAInputComponent label={formatMessage({id: 'placeholder.startTime'})}>
              <SATimePicker className={"right"} placeholder={formatMessage({id: "placeholder.startTime"})}
                            value={startTime} onChange={time => this.onTimePickerChange(time, 'startTime')}
                            defaultOpenValue={'07:00'}
                            error={errors['startTime']}/>
            </SAInputComponent>
          </li>
          <li>
            <SAInputComponent label={formatMessage({id: 'placeholder.endTime'})}>
              <SATimePicker className={"right"} placeholder={formatMessage({id: "placeholder.endTime"})}
                            value={endTime} onChange={time => this.onTimePickerChange(time, 'endTime')}
                            defaultOpenValue={'07:00'}
                            error={errors['endTime']} />
            </SAInputComponent>
          </li>
          <li>
            <SAInputComponent label={formatMessage({id: 'placeholder.duration'})}>
              <SATimePicker className={"right"} placeholder={formatMessage({id: "placeholder.duration"})}
                            format={"HH:mm"} disabledHours={() => Array.from(Array(24).keys()).filter(n=>n>=4)} hideDisabledOptions={true}
                            value={slotDuration} onChange={duration => this.onDurationChange(duration, 'slotDuration')}
                            error={errors['slotDuration']}/>
            </SAInputComponent>
          </li>
          <li>
            <SAInputComponent label={formatMessage({id: 'placeholder.teams-size'})}>
              <SAInputNumber className={"right"} placeholder={formatMessage({id: "placeholder.teams-size"})}
                             value={numberOfTeams} onChange={number => this.onInputNumberChange(number, 'numberOfTeams')}
                             min={1} error={errors['numberOfTeams']}/>
            </SAInputComponent>
          </li>
        </ul>
        <br/>

        <div className="ant-table-filter-dropdown-btns">
          <a onClick={this.onSave}
             className="ant-table-filter-dropdown-link confirm">{formatMessage({id: 'action.add'})}</a>
          <a onClick={this.resetState}
             className="ant-table-filter-dropdown-link clear">{formatMessage({id: 'action.cancel'})}</a>
        </div>
      </div>
    );

    return (
      <div className={"dropdown-wrapper"}>
        <Dropdown overlay={overlay} trigger={['click']}
                  onVisibleChange={this.handleVisibleChange}
                  visible={this.state.visible}>
          {this.props.children}
        </Dropdown>
      </div>
    )
  }
}

export default injectIntl(AddDayConfigurationMenu);



// WEBPACK FOOTER //
// ./src/components/wheelsexchange/configuration/AddDayConfigurationMenu.js